
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import gsap from 'gsap';


export default function initGallery() {
    const galleries = document.querySelectorAll('.component.gallery');

    galleries.forEach((container) => {
        const sliderEl = container.querySelector('.gallery__slider');
        const progressEl = container.querySelector('.progress span');
        const items = container.querySelectorAll('.items span');
        const itemsContainer = container.querySelector('.items');

        if (sliderEl && progressEl) {
            const swiper = new Swiper(sliderEl, {
                modules: [Autoplay],
                speed: 600,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                navigation: false,
                grabCursor: true,
                slidesPerView: 'auto',
                spaceBetween: 20,
                breakpoints: {
                    992: {
                        spaceBetween: 40
                    }
                },
                on: {
                    init: (swiper) => {
                        updateActiveItems(swiper, items, itemsContainer);
                        startProgress(progressEl);
                    },
                    slideChangeTransitionStart: (swiper) => {
                        updateActiveItems(swiper, items, itemsContainer);
                        startProgress(progressEl);
                    }
                }
            });

            items.forEach((item, i) => {
                item.addEventListener('click', () => {
                    swiper.slideTo(i);
                });
            });
        }
    });
}

function updateActiveItems(swiper, items, itemsContainer) {
    items.forEach((item, i) => {
        const isActive = i === swiper.activeIndex;
        item.classList.toggle('active', isActive);

        if (isActive && window.innerWidth < 992 && itemsContainer) {
            const containerWidth = itemsContainer.offsetWidth;
            const itemWidth = item.offsetWidth;
            const itemOffset = item.offsetLeft;
            const scrollLeft = itemOffset - (containerWidth / 2) + (itemWidth / 2);

            itemsContainer.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
            });
        }
    });
}

function startProgress(progressEl) {
    gsap.killTweensOf(progressEl);
    gsap.set(progressEl, { scaleX: 0, transformOrigin: 'left' });
    gsap.to(progressEl, {
        scaleX: 1,
        duration: 7,
        ease: 'none'
    });
}
